import React, { useEffect, useState, useMemo } from 'react';
import ApiService from '../service/ApiService';
import { Task } from '../types/Task';
import Form from '../components/Form';
import { useNavigate } from 'react-router-dom';
import { Table } from '../lib/table';
import { Button } from '../lib/button';

const TaskListTable: React.FC = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      { key: 'name', title: 'Name' },
      { key: 'description', title: 'Description' },
      { key: 'priority', title: 'Priority' },
      { key: 'category', title: 'Category' },
      { key: 'assignedTo', title: 'Assigned to' },
      { key: 'targetDate', title: 'Target date' },
    ],
    [],
  );

  const fetchTasks = async () => {
    try {
      const response = await ApiService.getTasks();
      setTasks(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
        <Form onSuccess={fetchTasks} />
        <Button onClick={() => navigate('/navigation')} variant="primary">
          Go to navigation
        </Button>
      </div>
      <Table
        data={tasks}
        columns={columns}
        rowKey={(item) => item.name + item.createdAt}
      />
    </div>
  );
};

export default TaskListTable;
